import React from "react";
import { Avatar } from "@heroui/react";
import { Typography } from "../../../../../../components";
import { OrderData } from "./utils";
import { useTranslations } from "../../../../../../contexts/translation.context";
import { useNavigate } from "react-router-dom";

interface OfferCellProps {
  order: OrderData;
}

const OfferCell: React.FC<OfferCellProps> = ({ order }) => {
  const { t } = useTranslations();
  const navigate = useNavigate();

  return (
    <div className="flex items-start gap-4">
      <Avatar
        src={order.offer.avatar}
        showFallback name={order.offer.name?.slice(0, 1)}
        className="w-8 h-8 rounded-lg"
      />
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <Typography variant="body2" className="text-gray-900">
            #{order.offer.id.slice(-4)}
          </Typography>
          <div
            className="flex items-center gap-1 text-blue-600 cursor-pointer"
            onClick={() => navigate(`/users/partners/${order.offer.id}/balance`)}
          >
            <Typography variant="body1" className="!text-[#006FEE] !text-[14px] !font-medium">
              {order.offer.name}
            </Typography>
          </div>
        </div>

        <div className="flex items-center gap-[4px] border-[#D4D4D8] border-[1.4px] h-[24px] rounded-xl px-[8px] w-fit">
          <div className="w-[14px] h-[14px]">{order.account.platformIcon}</div>
          <Typography variant="body3">
            {order.offer.platform}
          </Typography>
        </div>

        <div className="flex items-center gap-2">
          <Typography variant="body3" className="text-gray-600">
            {t('orders.offer.subscribers')}:
          </Typography>
          <Typography variant="body2" className="font-semibold text-gray-900">
            {order.offer.subscribers.toLocaleString()}
          </Typography>
        </div>

        <div className="flex items-center gap-2">
          <Typography variant="body3" className="text-gray-600">
            {t('orders.offer.pricePerSubscriber')}/
          </Typography>
          <Typography variant="body2" className="font-semibold text-gray-900">
            ${order.offer.pricePerSubscriber.toFixed(2)}
          </Typography>
        </div>

        {order.offer.description && (
          <Typography variant="body2" className="text-gray-900 max-w-60">
            {order.offer.description}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default OfferCell;
